/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_NameInputs */

const en_settings_apikeys_key_name = /** @type {(inputs: Settings_Apikeys_Key_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Name`)
};

const zh_settings_apikeys_key_name = /** @type {(inputs: Settings_Apikeys_Key_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密钥名称`)
};

/**
* | output |
* | --- |
* | "Key Name" |
*
* @param {Settings_Apikeys_Key_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_name = /** @type {((inputs?: Settings_Apikeys_Key_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_key_name(inputs)
	return zh_settings_apikeys_key_name(inputs)
});
export { settings_apikeys_key_name as "settings.apikeys.key_name" }